//
// Based on the demo code in Google Places javascript API docs.
// See: https://github.com/crmcmullen/medium-react-google-places/blob/main/src/service/google_place_autocomplete.js
//
// Must be called in the context of a Wrapper component from @googlemaps/react-wrapper.
// This is to ensure window.google.maps.places is defined.
//
import { northpowerBounds } from "../constants/northpowerBounds";

const useGooglePlaceAutoComplete = () => {

    const initAutoComplete = (inputElement, onPlaceChanged) => { // pass an options object and use in Autocomplete constructor
        const autoComplete = new window.google.maps.places.Autocomplete(inputElement, {
                bounds: northpowerBounds,
                componentRestrictions: { country: ["nz"] },
                fields: ["address_components", "geometry", "formatted_address", "place_id"],
                types: ["address"]
            }
        )
        autoComplete.addListener("place_changed", onPlaceChanged)
        return autoComplete
    }

    /**
     * 
     * @param {object} autoComplete Google places autocomplete
     * @returns {addressComponents, geometry, formattedAddress, placeId}
     */
    const getFullPlace = (autoComplete) => {

        if (!autoComplete) {
            console.error('Make sure you call initAutoComplete before getFullPlace')
            return {}
        }

        const place = autoComplete.getPlace()
        console.log('getFullPlace place', place)
        
        const fullPlace = {
            addressComponents: place.address_components,
            geometry: place.geometry,
            formattedAddress: place.formatted_address,
            placeId: place.place_id
        }

        console.log('fullPlace', fullPlace)
        return fullPlace
    }

    return {
        initAutoComplete,
        getFullPlace
    }

}

export default useGooglePlaceAutoComplete